export const nonBreakingSpace = '\u00a0';
